import { Chip } from '@mui/material';
import { primary, white } from '../../constants/Colors';
import React from 'react';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    texto: string;
    icon?: JSX.Element;
    backgroundColor?: string;
    color?: string;
}

function BadgeCustom({ texto, icon, backgroundColor = white, color = primary }: Props): JSX.Element {

    const style: React.CSSProperties = {
        background: backgroundColor,
        marginLeft: '0.5em',
        color: color,
        fontSize: '0.8em',
        fontWeight: 'bold',
        userSelect: 'none',
    };

    return (
        <Chip size="small" icon={icon} label={texto} style={style} />
    );
}

export default BadgeCustom;
